function handleBuyNotices() {
    if (tlGlobal.isCheckout) {
        return
    }
    const buyNotices = document.querySelector('#buy-notices')
    let buyNoticeTime = sessionStorage.getItem('buyNoticeTime') || 10000 // get time from session storage, or use default if not set
    let intervalId = setInterval(fetchBuyNotice, buyNoticeTime)

    function fetchBuyNotice() {
        const data = new FormData()
        data.append('action', 'get_buy_notice')
        data.append('security', tlGlobal.getBuyNotice)

        fetch(tlGlobal.adminUrl, {
            method: 'POST',
            body: data,
        })
            .then((response) => response.text())
            .then((data) => {
                if (data.length > 0) {
                    buyNotices.innerHTML = data

                    if (buyNotices.childNodes.length > 0) {
                        const buyNotice = buyNotices.querySelector('.buy-notice')

                        setTimeout(() => {
                            buyNotice.classList.add('show')
                        }, 100)

                        setTimeout(() => {
                            buyNotice.classList.remove('show')
                        }, 5000)
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    // update time interval after first execution
    setTimeout(() => {
        clearInterval(intervalId)
        buyNoticeTime = 60000
        sessionStorage.setItem('buyNoticeTime', buyNoticeTime) // store new time in session storage
        intervalId = setInterval(fetchBuyNotice, buyNoticeTime)
    }, buyNoticeTime)
}

document.body.addEventListener('click', function (e) {
    if (e.target.classList.contains('close-buy-notice')) {
        e.target.parentNode.classList.remove('show')
    }
})

document.addEventListener('DOMContentLoaded', handleBuyNotices)
